module.exports = __webpack_public_path__ + "static/products-eda5eac9f94f9fd3d4dd61ba2edff948.jpg";